<div class="billing-container">
	<div class="address-toggle">
		@if (order.billingInformations.sameCompanyAndContactPersonAsProvided) {
			<nb-toggle
				class="toggle-component toggle-row" disabled
				[checked]="order.billingInformations.sameCompanyAndContactPersonAsProvided"
				status="primary">
				Address and contact information same as already given
				<change-label [visible]="isSameCompanyChanged()" [changeSet]="changeSet"></change-label>
			</nb-toggle>
		}
	</div>
	@if (!order.billingInformations.sameCompanyAndContactPersonAsProvided) {
		<div class="details">
			<address-details [order]="order" [showMultiSiteQuestion]="false"
							 [isBillingAddress]="true" [changeSet]="contactDetailsChangeSet">
			</address-details>
			<contact-person-details [contactPerson]="order.billingInformations.billingContactPerson"
									[isBillingContact]="true" [changeSet]="contactDetailsChangeSet">
			</contact-person-details>
		</div>
	}

	<div class="radio-row">
		<div class="radio-with-question">
			<div class="radio-description-column">
				<span>Is Purchase Order number required for payment?</span>
			</div>
			<div class="radio-column">
				<nb-radio [name]="uniqueName('purchaseNumber')" [checked]="true" status="primary">
					{{ order.billingInformations.isPurchaseNumberRequiredForPayment | booleanDisplay }}
				</nb-radio>
				<change-label [visible]="isPurchaseRequiredChanged()" [changeSet]="changeSet"></change-label>
			</div>
		</div>
	</div>
	@if (order.billingInformations.isPurchaseNumberRequiredForPayment) {
		<div class="text-row">
			<span class="text-row-label">PURCHASE ORDER NUMBER</span>
			<change-label [visible]="isPurchaseNumberChanged()" [changeSet]="changeSet"></change-label>
			<p class="text-value">{{ order.billingInformations.purchaseOrderNumber }}</p>
		</div>
	}

	@if (order.billingInformations.isPurchaseNumberRequiredForPayment) {
		<div class="radio-row">
			<div class="radio-with-question">
				<div class="radio-description-column">
					<span>Does Purchase Order cover travel expenses at cost in addition to professional fee?</span>
				</div>
				<div class="radio-column">
					<nb-radio [name]="uniqueName('expenses')" [checked]="true" status="primary">
						{{ order.billingInformations.coverTravelExpenses | booleanDisplay }}
					</nb-radio>
					<change-label [visible]="isCoverTravelExpensesChanged()" [changeSet]="changeSet"></change-label>
				</div>
			</div>
		</div>
	}

	<div class="text-row">
		<span class="text-row-label">ADDITIONAL BILLING INFORMATION</span>
		<change-label [visible]="isAdditionalInformationChanged()" [changeSet]="changeSet"></change-label>
		@if (order.billingInformations.additionalInformation; as value) {
			<p class="text-value">{{ value }}</p>
		} @else {
			<p class="text-value placeholder">answer was not provided</p>
		}
	</div>


	@if (editable) {
		<div class="change-button">
			<button id="change-button" nbButton status="warning" outline (click)="goToEditMode()">EDIT</button>
		</div>
	}
</div>
